import{ReferringObject}from'./ReferringObject';export class ReferringDialog extends ReferringObject{}